"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasureDropdownItem = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var util_1 = require("@gooddata/util");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
exports.MeasureDropdownItem = function (_a) {
    var item = _a.item, isSelected = _a.isSelected, onSelect = _a.onSelect, onDropDownItemMouseOver = _a.onDropDownItemMouseOver, onDropDownItemMouseOut = _a.onDropDownItemMouseOut, enableRenamingMeasureToMetric = _a.enableRenamingMeasureToMetric;
    var title = item.title, ref = item.ref, sequenceNumber = item.sequenceNumber;
    var className = classnames_1.default("gd-list-item", "gd-list-item-shortened", {
        "is-selected": isSelected,
    }, "gd-button-link", enableRenamingMeasureToMetric ? "gd-icon-metric" : "gd-icon-measure", "s-rf-measure-" + util_1.stringUtils.simplifyText(title));
    var onMouseOver = function () {
        if (onDropDownItemMouseOver) {
            onDropDownItemMouseOver(ref);
        }
    };
    var onMouseOut = function () {
        if (onDropDownItemMouseOut) {
            onDropDownItemMouseOut();
        }
    };
    return (react_1.default.createElement("button", { className: className, onClick: function () { return onSelect(ref); }, onMouseOver: onMouseOver, onMouseOut: onMouseOut, title: title },
        react_1.default.createElement("span", { className: "gd-rf-measure-title" }, title),
        sequenceNumber ? react_1.default.createElement("span", { className: "gd-rf-sequence-number" }, sequenceNumber) : null));
};
//# sourceMappingURL=MeasureDropdownItem.js.map